__turbopack_context__.v({
  "darkFilledModelImageBackgroundGradient": "styles-module__l-nsAW__darkFilledModelImageBackgroundGradient",
  "lightModelImageBackgroundGradient": "styles-module__l-nsAW__lightModelImageBackgroundGradient",
  "model-group-switch-from-right": "styles-module__l-nsAW__model-group-switch-from-right",
  "model-next-card-hint": "styles-module__l-nsAW__model-next-card-hint",
  "modelCardBorder": "styles-module__l-nsAW__modelCardBorder",
  "modelCardBorderDark": "styles-module__l-nsAW__modelCardBorderDark",
  "modelCardBorderDarkFull": "styles-module__l-nsAW__modelCardBorderDarkFull",
  "modelCardBorderLight": "styles-module__l-nsAW__modelCardBorderLight",
  "modelCardCarouselReveal": "styles-module__l-nsAW__modelCardCarouselReveal",
  "modelCardImageMedia": "styles-module__l-nsAW__modelCardImageMedia",
  "modelListNextCardHint": "styles-module__l-nsAW__modelListNextCardHint",
  "xSeriesSectionBg": "styles-module__l-nsAW__xSeriesSectionBg",
});
